import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
// import { useTranslation } from "react-i18next";
import { PowerBIEmbed } from "powerbi-client-react";
import { models, Report, Embed } from "powerbi-client";
import { BarChart } from "@mui/icons-material";
import { Title } from "./styles";

import { Grid } from "@mui/material";
import { useExternalDashboardsAccessToken } from "services/input-core/power-bi/get-access-token";
import { useSubscription } from "store/auth/auth-store";
import Card from "components/UI/Card/Card";
import CardHeader from "components/UI/Card/CardHeader";
import CardIcon from "components/UI/Card/CardIcon";
import CardBody from "components/UI/Card/CardBody";

interface ExternalDashboardTitle {
  name: string;
  show: boolean;
}

type Sources = "POWER_BI" | "PENTAHO" | "OTHERS";

export interface Dashboard {
  workspaceID: string;
  reportId: string;
  source: Sources;
  order: number;
  title: ExternalDashboardTitle;
  authAlias: string;
  embedUrl: string;
}

const PowerBIReport: React.FC = () => {
  // const { t } = useTranslation("power-bi");
  const location = useLocation();
  const { state } = location;
  const { subscription } = useSubscription();
  const dashboards: Dashboard[] = state?.dashboards as Dashboard[];

  const [, setReport] = useState<Report>();
  const [accessTokens, setAccessTokens] = useState<{ [key: string]: string }>(
    {},
  );

  const {
    mutate: getExternalDashboardsAccessToken,
  } = useExternalDashboardsAccessToken(subscription?.subscriptionId);

  useEffect(() => {
    if (dashboards) {
      dashboards.forEach((dashboard) => {
        getExternalDashboardsAccessToken(dashboard.authAlias, {
          onSuccess: (data) => {
            setAccessTokens((prevTokens) => ({
              ...prevTokens,
              [dashboard.authAlias]: data.accessToken,
            }));
          },
        });
      });
    }
  }, [dashboards, getExternalDashboardsAccessToken]);

  if (!dashboards) {
    return <div>No dashboard found</div>;
  }

  const getEmbedConfig = (dashboard: Dashboard): any => {
    if (dashboard.source === "POWER_BI") {
      return {
        type: "report",
        id: dashboard.reportId,
        embedUrl: dashboard.embedUrl,
        accessToken: accessTokens[dashboard.authAlias],
        tokenType: models.TokenType.Embed,
        settings: {
          panes: {
            filters: {
              expanded: false,
              visible: false,
            },
          },
        },
      };
    }
    return null;
  };

  const renderReport = (dashboard: Dashboard) => {
    switch (dashboard.source) {
      case "POWER_BI": {
        const embedConfig = getEmbedConfig(dashboard);
        return (
          <div className="report-container">
            <PowerBIEmbed
              embedConfig={embedConfig}
              cssClassName="report-style-class"
              getEmbeddedComponent={(embedObject: Embed) => {
                console.log(
                  `Embedded object of type "${embedObject.embedtype}" received`,
                );
                setReport(embedObject as Report);
              }}
            />
          </div>
        );
      }
      case "PENTAHO":
        return (
          <div className="pentaho-report-container">
            Pentaho report content here
          </div>
        );

      case "OTHERS":
        return (
          <div className="others-report-container">
            Other report content here
          </div>
        );

      default:
        return <div>Unsupported report source</div>;
    }
  };

  return (
    <Grid container spacing={2}>
      {dashboards?.map((dashboard, index) => (
        <Grid item xs={12} key={index}>
          <Card>
            <CardHeader color="rose" icon data-cy="power-bi-header">
              <CardIcon color="rose">
                <BarChart />
              </CardIcon>
              {dashboard?.title?.show && (
                <Title>{dashboard?.title?.name}</Title>
              )}
            </CardHeader>
            <CardBody>{renderReport(dashboard)}</CardBody>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default PowerBIReport;
